import { ISaveFeeType } from "../../Interfaces";

export function AddNewFeeType(this: any): ISaveFeeType {
  return {
    feeTypeName: this.feeTypeName,
    description:this.description,
  };
}
